export default __webpack_public_path__ + "89240019a08c47cf02e42e7dfc7e0273.svg";